import React, { useEffect, useMemo, useState } from "react";

const API_BASE = process.env.REACT_APP_NAV_API || process.env.REACT_APP_API_BASE || "http://localhost:8080";

function safeText(s) {
  return (s ?? "").toString();
}

export default function AnnouncementTicker() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);

async function load() {
  setErr("");
  try {
    const res = await fetch(
      `${API_BASE}/posts?status=PUBLISHED&post_type=ANNOUNCEMENT&limit=30`,
      {
        method: "GET",
        credentials: "include", // ✅ add this line
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const json = await res.json();
    if (!res.ok || !json.ok) throw new Error(json?.error || "Failed to load announcements");

    const arr = Array.isArray(json.data) ? json.data : [];
    setItems(arr);
  } catch (e) {
    setErr(e?.message || String(e));
    setItems([]);
  }
}

  useEffect(() => {
    load();
    // (optional) refresh every 60s
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const textItems = useMemo(() => {
    // show only title (and optional priority)
    return items
      .filter((x) => x?.title)
      .map((x) => {
        const pr = x?.payload?.priority ? `[${x.payload.priority}] ` : "";
        return { ...x, __label: pr + safeText(x.title) };
      });
  }, [items]);

  const hasItems = textItems.length > 0;

  function onClickItem(item) {
    setActive(item);
    setOpen(true);
  }

  function closeModal() {
    setOpen(false);
    setActive(null);
  }

  if (!hasItems) {
    // keep a thin bar even if empty (optional)
    return (
      <div className="announceBar">
        <div className="announceInner">
          <div className="announceMuted">
            {err ? `⚠ ${err}` : "No announcements"}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="announceBar">
        <div className="announceInner">
          <div className="announceTrack" title="Announcements">
            {/* Duplicate the list to create seamless scroll */}
            <div className="announceMarqueeWrapper">
            <div className="announceMarquee">
              {[...textItems, ...textItems].map((it, idx) => (
                <span
                  key={`${it.post_id || idx}-${idx}`}
                  className="announceItem"
                  onClick={() => onClickItem(it)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") onClickItem(it);
                  }}
                >
                  <span className="announceDot">•</span>
                  {it.__label}
                </span>
              ))}
            </div>
            </div>

          </div>
        </div>
      </div>

      {/* Modal */}
      {open && active ? (
        <div className="announceModalBackdrop" onClick={closeModal}>
          <div className="announceModal" onClick={(e) => e.stopPropagation()}>
            <div className="announceModalTop">
              <div className="announceModalTitle">{active.title}</div>
              <button className="announceCloseBtn" onClick={closeModal}>
                ✕
              </button>
            </div>

            {active.cover_image_url ? (
              <img
                src={active.cover_image_url}
                alt="Announcement"
                className="announceModalImg"
              />
            ) : null}

            <div className="announceModalDesc">{active.description}</div>

            {active?.payload?.action_url ? (
              <div style={{ marginTop: 12, display: "flex", justifyContent: "flex-end" }}>
                <a
                  className="announceActionBtn"
                  href={active.payload.action_url}
                  target="_blank"
                  rel="noreferrer"
                >
                  {active?.payload?.button_text || "View"}
                </a>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
}